<button [ngClass]="{invert:invertColor, flat:flat, link:link, bold:bold }" [disabled]="disabled" (click)="click" [type]="type">
  <ng-content></ng-content>
</button>
